import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { AttributeStrategyType, useAttributeStrategy, } from "./AttributeStrategyProvider";
import { LayoutAttributeStrategy } from "./LayoutAttributeStrategy";
import { SimpleAttributeStrategy } from "./SimpleAttributeStrategy";
export function AttributeStrategy() {
    const { strategy } = useAttributeStrategy();
    return (_jsxs(_Fragment, { children: [strategy === AttributeStrategyType.Simple && _jsx(SimpleAttributeStrategy, {}), strategy === AttributeStrategyType.Layout && _jsx(LayoutAttributeStrategy, {})] }));
}
//# sourceMappingURL=AttributeStrategy.js.map